import { useParams } from 'react-router-dom';
import { Text } from '../../components/units/Text';
import { useEffect, useState } from 'react';
import { Divider } from '../../components/units/Divider';
import React from 'react';
import { DetailText } from '../../components/units/Text';
import { AccumulatorDetailWidget, SohWidget, AccumulatorProfileWidget, EfficiencyWidget, CyclesWidget, StatisticsCharts, WidgetTitle, IconLocation} from '../../components/Accumulator/Widgets';
import { fetchAcbDetails, FetchChartData, AccumulatorDetails } from '../../components/Rest/FetchACB';
import './ACBView.css'
import { BoxWrapper, ConditionalWrapper } from '../../components/Wrappers/Wrappers';
import { DateRangeEnum, DateRangePicker, dateRangeValues} from '../../components/Pickers/dataRange';
import { useSignedInContext } from '../../context/AuthContextProvider';
import { ChartDataResponse } from '../../components/Rest/FetchACB';
import { ServiceInfo } from '../../components/Accumulator/ServiceInfo';
// import { fetchCommissionData, CommisionProps } from '../../components/Rest/Commission';
import { fetchCommissionData } from '../../components/Rest/accumulator/components/fetchCommissionData';
import { CommisionProps } from '../../components/Rest/accumulator/interfaces/commission';
import { hasPermission } from '../../roles/roles';
import { JournalHandler } from '../../components/Journal/Journal';
import { fetchJournal, JournalResponse } from '../../components/Rest/Journal';
import { RestApiState } from '../../components/Rest/Organization';
import { downloadJournal } from '../../components/Rest/Journal';
import { UpdateOs } from '../../components/Accumulator/UpdateOs';
import { Loader } from '../../components/units/Loader';
// TODO add cache
// Refactor everything!!!

const MapWrapper = React.memo(
    () => {
        return <div id="map-container" style={{ width: '100%', height: '100%' }}></div>;
    },
    () => true,
);


type coordinates = {
    Latitude: string;
    Longitude: string;
}
interface MapProps {
    coords: coordinates | null 
}

const Map = ({ coords }: MapProps) => {
    useEffect(() => {
        const defaultMapCenter = [55.751244, 37.618423]
        const map = new window.DG.map('map-container', {
            center: coords ?  [coords.Latitude, coords.Longitude] : defaultMapCenter,
            zoom: 13
        });

        const greenHtmlIcon = window.DG.divIcon({
            className: 'custom-html-icon', // Add a custom class to style the marker
            html: '<div class="green-marker"></div>', // HTML content of the marker
            iconSize: [16, 16], // Size of the marker
            iconAnchor: [16, 16], // Anchor of the marker
            popupAnchor: [0, 0], // Popup anchor point
        });

        // Example: Adding a marker to the map
        if (coords) {
            window.DG.marker([coords.Latitude, coords.Longitude], { icon: greenHtmlIcon }).addTo(map).bindPopup('This is Location 🔋!');
        }
        
    }, [coords]);

    return (<div id="map-container" style={{ width: '100%', height: '500px' }}/>);
};


const LocationWidget = (accumulator: AccumulatorDetails | undefined) => {

    return (
        <BoxWrapper className="flex flex-column no-padding show-up-quick" bg="bg-primary" p="p0" r="r15">
            <div className="default-padding" style={{paddingBottom: 0}}>
                <WidgetTitle label="Местоположение батареи" icon={IconLocation()} />
                <div className="default-padding">
                    <Text size="sm" color="orange">Местоположение определено по GSM (точность определения  - до 1000 метров)</Text>
                </div>
            </div>
            {
                accumulator ? (
                    <div className="chart four-cols">
                        <Map coords={accumulator.coordinates}/>
                    </div>
                ) : (
                    <div>
                        <Text>Нет данных</Text>
                    </div>
                )
            }
  
        </BoxWrapper>
    )
}

export enum InfoBlock {
    StatisticsInfo,
    LocationInfo,
    NotificationInfo,
    Journal,
    ConfigInfo,
    DocumentationInfo,
    ServiceInfo,
    OS,
}


export interface CommissionViewProps {
    data: CommisionProps | null;
}

// TODO refactor it in future
export type RangeParams = {
    isOpen: boolean;
    range: DateRangeEnum
}

export type JournalParams = {
    isMessage: boolean;
    isWarning: boolean;
    isError: boolean;
    isBmsEvent: boolean;
    search?: string;
    ordering?: string;
    limit:number;
    offset:number;
    currentPage: number;
    timeout: NodeJS.Timeout | undefined;
    dateRange: RangeParams;
}

export interface PaginationProps {
    isOpen : boolean;
}

export interface JournalProps {
    data: JournalResponse | null;
    params: JournalParams;
    pagination: PaginationProps;
    download: {
        requestState: RestApiState;
        btnDisabled: boolean;
        timeout : NodeJS.Timeout | null;
    }
}

export interface AcbViewProps {
    commission: CommissionViewProps;
    journal: JournalProps;
}


const ACBView = () => {
    // Refactor all of those useStates
    const { user } = useSignedInContext()
    const { serial_number } = useParams()
    if (!serial_number) {
        throw new Error("Serial number must be provided")
    }

    const [infoBlock, setInfoBlock] = useState<InfoBlock>(InfoBlock.StatisticsInfo)
    const [accumulator, setAccumulator] = useState<AccumulatorDetails | undefined>(undefined)
    const [chartData, setChartData] = useState<ChartDataResponse>({data: null})
    const [dateRange, setDateRange] = useState<DateRangeEnum>(DateRangeEnum.Month)
    const [dateRangeOpen, setDateRangeOpen] = useState<boolean>(false)

    const [viewProps, setViewProps] = useState<AcbViewProps>({
        // TODO move every related prop into viewProps
        commission: {
            data : null
        }, 
        journal: {
            data:null, 
            params: {
                    isMessage: false,
                    isWarning: true,
                    isError: true,
                    isBmsEvent: false,
                    limit: 10,
                    currentPage: 1,
                    offset: 0,
                    timeout: undefined,
                    dateRange: { //TODO move dateRange out of param branch
                        isOpen: false,
                        range: DateRangeEnum.Month
                    },
            },
            pagination: {
                isOpen: false,
            },
            download: {
                requestState: RestApiState.Idle,
                btnDisabled: false,
                timeout: null,
            }
        }
    })

    if (serial_number === undefined) {
        throw "Serial number must be provided as parameter"
    }

    const setCommissionData = (newData: typeof viewProps.commission.data): void => {
        setViewProps(prev => ({
            ...prev,
            commission: {
              ...prev.commission,
              data: newData,
            },
        }));
    }

    const setJournalPagination = (value: number): void => {
        setViewProps(prev => ({
            ...prev,
            journal: {
                ...prev.journal, 
                params: {
                    ...prev.journal.params,
                    limit : value
                }
            } 
        }))

        setViewProps(prev => ({
            ...prev,
            journal: {
                ...prev.journal,
                params: {
                    ...prev.journal.params,
                    currentPage: 1
                }
            }
        }))
    }

    const setJournalParam = (e: React.ChangeEvent<HTMLInputElement>):void => {
        const { name, value } = e.target;
        setViewProps(prev => ({
            ...prev,
            journal: {
                ...prev.journal,
                params: {
                    ...prev.journal.params,
                    [name]: e.target.checked
                }
            }
        }))
    }

    const setJournalPage = (value: number) => {
        setViewProps(prev => ({
            ...prev,
            journal: {
                ...prev.journal,
                params: {
                    ...prev.journal.params,
                    currentPage: value
                }
            }
        }))
    }

    const setJournalRange = (value: DateRangeEnum) => {
        setViewProps(prev => ({
            ...prev,
            journal: {
                ...prev.journal,
                params: {
                    ...prev.journal.params,
                    dateRange: {
                        ...prev.journal.params.dateRange,
                        range: value
                    }
                }
            }
        }))
    }

    const setJournalOpen = (value: boolean) => {
        setViewProps(prev => ({
            ...prev,
            journal: {
                ...prev.journal,
                params: {
                    ...prev.journal.params,
                    dateRange: {
                        ...prev.journal.params.dateRange,
                        isOpen: value
                    }
                }
            }
        }))
    }

    useEffect(() => {
        const fetchList = async () => {
            setChartData({data: null})
            await fetchAcbDetails(user.role_slug, serial_number, setAccumulator)
            // await FetchChartData(user.role_slug, serial_number, setChartData, dateRangeValues(dateRange))
        }
        fetchList()
    }, [serial_number])

    useEffect(() => {
        const fetchSectionData = async () => {
            if (infoBlock === InfoBlock.ServiceInfo) {
                fetchCommissionData(serial_number, user.role_slug, setCommissionData)
            } else if (infoBlock === InfoBlock.Journal) {
                fetchJournal(
                    serial_number, 
                    user.role_slug, 
                    (value: JournalResponse) => {
                        setViewProps(prev => ({
                            ...prev,
                            journal: {
                                ...prev.journal,
                                data : value
                            }
                        }))
                    }, 
                    viewProps.journal.params
                )
            } else if (infoBlock === InfoBlock.StatisticsInfo) {
                FetchChartData(user.role_slug, serial_number, setChartData, dateRangeValues(dateRange))
            }
        }
        fetchSectionData()
    }, [infoBlock, dateRange, viewProps.journal.params])


    return (
        <div className='content-wrapper acb-dashboard-wrapper show-up'>
            <DetailText href='/react/'>
                Назад
            </DetailText>
            <br />
            <br />
            <div className="acb-header">
                {accumulator !== undefined ? (
                    <>
                    { AccumulatorProfileWidget(accumulator) } 
                    { AccumulatorDetailWidget(accumulator) }
                    { SohWidget(accumulator, setInfoBlock) }
                    { EfficiencyWidget(accumulator)}
                    { CyclesWidget(accumulator) }
                    </>

                ): (
                    <>
                        <Loader/>
                        <Loader/>
                        <Loader/>
                        <Loader/>
                        <Loader/>
                    </>
                )}
            </div>
            <br />
            <div className='full-width overflow-x-auto text-no-wrap no-scroll-bar'>
                <div className='h-wrapper'>
                    <div className="selectors">
                        <Text 
                            size="xl" 
                            color={ infoBlock === InfoBlock.StatisticsInfo ? 'primary' : 'secondary' } 
                            className={`bold fit pointer ${infoBlock === InfoBlock.StatisticsInfo ? 'selected' : ''}`}
                            onClick={(e)=>setInfoBlock(InfoBlock.StatisticsInfo)}
                            >Статистика</Text>
                        <ConditionalWrapper condition={hasPermission({role:user.role, resource:'Commission', action:'view'})}>
                            <Text 
                                size="xl" 
                                color={ infoBlock === InfoBlock.ServiceInfo ? 'primary' : 'secondary' } 
                                className={`bold fit pointer ${infoBlock === InfoBlock.ServiceInfo ? 'selected' : ''}`}
                                onClick={(e)=>setInfoBlock(InfoBlock.ServiceInfo)}
                                >Служебная информация</Text>
                        </ConditionalWrapper>
                        <ConditionalWrapper condition={hasPermission({role:user.role, resource:'OS', action:'view'})}>
                            <Text 
                                size="xl" 
                                color={ infoBlock === InfoBlock.OS ? 'primary' : 'secondary' } 
                                className={`bold fit pointer ${infoBlock === InfoBlock.OS ? 'selected' : ''}`}
                                onClick={(e)=>setInfoBlock(InfoBlock.OS)}
                                >OS</Text>
                        </ConditionalWrapper>
                        <Text 
                            size="xl" 
                            color={ infoBlock === InfoBlock.Journal ? 'primary' : 'secondary' } 
                            className={`bold fit pointer ${infoBlock === InfoBlock.Journal ? 'selected' : ''}`}
                            onClick={(e)=>setInfoBlock(InfoBlock.Journal)}
                            >Журнал</Text>
                        <Text 
                            size="xl" 
                            color={ infoBlock === InfoBlock.LocationInfo ? 'primary' : 'secondary' } 
                            className={`bold fit pointer ${infoBlock === InfoBlock.LocationInfo ? 'selected' : ''}`}
                            onClick={(e)=>setInfoBlock(InfoBlock.LocationInfo)}
                            >Локация</Text>
                    </div>
                </div>
            </div>
            <Divider />
            { infoBlock === InfoBlock.StatisticsInfo && StatisticsCharts(chartData, dateRangeOpen, dateRange, setDateRangeOpen, setDateRange)}
            { infoBlock === InfoBlock.LocationInfo && LocationWidget(accumulator)}
            { infoBlock === InfoBlock.Journal && 
                <JournalHandler 
                    rangeProps={{
                        isOpen: viewProps.journal.params.dateRange.isOpen,
                        dateRange: viewProps.journal.params.dateRange.range,
                        setDateRangeOpen: setJournalOpen,
                        setDateRange: setJournalRange
                    }}
                    downloadButton={{
                        postStatus: viewProps.journal.download.requestState,
                        timeOutId: viewProps.journal.download.timeout,
                        disabled: viewProps.journal.download.btnDisabled,
                        restSetter: (key: 'requestState' | 'timeOutId', value: any) => {
                            setViewProps(prev => ({
                                ...prev,
                                journal: {
                                    ...prev.journal,
                                    download : {
                                        ...prev.journal.download,
                                        [key]: value
                                    }
                                }
                            }))
                        },
                        action: (e: any) => {
                            e.preventDefault();
                            downloadJournal(serial_number, user.role_slug, (value: RestApiState) => {
                                setViewProps(prev => ({
                                    ...prev,
                                    journal: {
                                        ...prev.journal,
                                        download: {
                                            ...prev.journal.download,
                                            requestState: value
                                        }
                                    }
                                }))
                            }, viewProps.journal.params)
                        }
                    }}
                    setJournalParam={setJournalParam}
                    paginationProps = {{
                        isOpen : viewProps.journal.pagination.isOpen,
                        setValue : setJournalPagination,
                        setOpen : (value: boolean) => {
                            setViewProps(prev => ({
                                ...prev,
                                journal: {
                                    ...prev.journal,
                                    pagination: {
                                        ...prev.journal.pagination,
                                        isOpen: value
                                    }
                                }
                            }))
                        }
                    }}
                    
                    data={viewProps.journal.data}
                    currentPage={viewProps.journal.params.currentPage}
                    itemsPerPage={viewProps.journal.params.limit}
                    params={ viewProps.journal.params }
                    // quick fix, to be amended
                    setter={ setJournalPage }
                    orderSetter={ (value: string) => {} }

                />}
            { (infoBlock === InfoBlock.ServiceInfo && hasPermission({role:user.role, resource:'Commission', action:'view'}))  && ServiceInfo(serial_number, viewProps.commission)}
            
           <ConditionalWrapper condition={infoBlock===InfoBlock.OS && hasPermission({role:user.role, resource:'OS', action:'view'})}>
                <UpdateOs />
            </ConditionalWrapper>
        </div>
    )    
}

export default ACBView